import { useQueryClient } from '@tanstack/react-query';

import { Modal } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { ResponsibilityLetterQueryKeys } from '@constants';

import type { ResponsibilityLetterModalProps } from './types';

export function ResponsibilityLetterModal({
  openModal,
  toggleModal,
}: Readonly<ResponsibilityLetterModalProps>) {
  const queryClient = useQueryClient();

  const handleToggleModal = () => {
    const usersQueryKey = [
      ResponsibilityLetterQueryKeys.HISTORY_RESPONSIBILITY_LETTER_STATE,
      ResponsibilityLetterQueryKeys.RESPONSIBILITY_LETTER_STATE,
    ];

    usersQueryKey.forEach(queryKey => {
      queryClient.removeQueries({
        queryKey: [queryKey],
        exact: true,
      });
      queryClient.refetchQueries({
        queryKey: [queryKey],
      });
    });

    toggleModal();
  };

  return (
    <Modal
      type="success"
      icon="actions-b2b-check-circle-filled"
      open={openModal}
      handleCloseModal={handleToggleModal}
      mainButtonText="Fechar"
      mainAction={handleToggleModal}
      color={NEW_COLORS.SEMANTICS.SUCCESS[500]}
      title="Carta de responsabilidade aceita com sucesso!"
    />
  );
}
